/*
 * breadcrumb-context.js
 * Tracks the user's last visited collection or search query in sessionStorage.
 * On product pages, replaces the auto-fallback breadcrumb segment with the
 * remembered source so users can navigate back to where they came from.
 *
 * Storage key: tcLastSource = { type: 'collection'|'search', url, label }
 */
(function () {
  var STORAGE_KEY = 'tcLastSource';

  function recordCurrentPage() {
    var path = window.location.pathname;
    var search = window.location.search;

    // Collection page: /collections/{handle} (but NOT /collections/X/products/Y)
    var collectionMatch = path.match(/^\/collections\/([^\/]+)\/?$/);
    if (collectionMatch) {
      var label = document.querySelector('.collection-hero__title');
      var labelText = label ? label.textContent.trim() : decodeURIComponent(collectionMatch[1]).replace(/-/g, ' ');
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        type: 'collection',
        url: path,
        label: labelText,
      }));
      return;
    }

    // Search page: /search?q=...
    if (path === '/search') {
      var params = new URLSearchParams(search);
      var q = params.get('q');
      if (q) {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
          type: 'search',
          url: '/search?q=' + encodeURIComponent(q),
          label: 'Search: "' + q + '"',
        }));
      }
      return;
    }

    // Product page: don't store, don't clear (the product page reads from sessionStorage)
    if (/^\/(collections\/[^\/]+\/)?products\//.test(path)) {
      return;
    }

    // Any other page (home, blog, page, cart, etc.): clear stale session
    // so the next product page doesn't show an unrelated breadcrumb source.
    sessionStorage.removeItem(STORAGE_KEY);
  }

  function overrideBreadcrumbOnProductPage() {
    // Only run on product pages
    if (!/^\/(collections\/[^\/]+\/)?products\//.test(window.location.pathname)) return;

    var middle = document.querySelector('[data-bc-segment="middle"]');
    if (!middle) return;

    // URL-based collection is authoritative — don't override
    if (middle.getAttribute('data-bc-source') === 'url') return;

    // Read sessionStorage
    var raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    var source;
    try { source = JSON.parse(raw); } catch (e) { return; }
    if (!source || !source.url || !source.label) return;

    // Replace the middle segment
    middle.setAttribute('href', source.url);
    middle.textContent = source.label;
    middle.setAttribute('data-bc-source', 'session-' + source.type);
  }

  function attachPredictiveSearchListener() {
    // When the user clicks a result inside the predictive search dropdown,
    // capture the current search query and store it as the session source.
    // This handles the case where users bypass /search via autocomplete.
    document.addEventListener('mousedown', function (e) {
      var link = e.target.closest && e.target.closest('predictive-search a[href*="/products/"]');
      if (!link) return;

      var input = link.closest('predictive-search') && link.closest('predictive-search').querySelector('input[name="q"]');
      var q = input ? input.value.trim() : '';
      if (!q) return;

      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        type: 'search',
        url: '/search?q=' + encodeURIComponent(q),
        label: 'Search: "' + q + '"',
      }));
    }, true);
  }

  function init() {
    recordCurrentPage();
    overrideBreadcrumbOnProductPage();
    attachPredictiveSearchListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
